var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button is-primary is-outlined",on:{"click":_vm.signOut}},[_vm._v(" "+_vm._s(_vm.$Amplify.I18n.get('Logout'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }